// LoginPage.js
import React from "react";
import { Login, LoginForm } from "react-admin";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';
import ForgotPasswordButton from './CustomForgotPassword'
import {Typography} from "@material-ui/core";
import {useFormState} from 'react-final-form';
import {makeStyles} from "@material-ui/core/styles";

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '#/',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID
  ]
};

const SignInScreen = () => <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>;

const CustomLoginForm = props => (
  <div>
    <div style={{fontFamily: "monospace", marginLeft: '15px'}}>
      <p>Username: test@example.com</p>
      <p>Password: password</p>
    </div>
    <LoginForm {...props} id={'loginForm'}/>
    <ForgotPasswordButton id={'forgotPasswordButton'} {...props} />
    <SignInScreen />
  </div>
);

const useStyles = makeStyles((theme) => ({
    typography: {
        textAlign: "center"
    }
}));


const CustomLoginPage = props => {
    const classes = useStyles();

    return (
        <Login {...props} backgroundImage={'/backgroundImage.jpg'}>
            <Typography component="h1" variant="h5" className={classes.typography}>
                Infinity Production Tracker
            </Typography>
            <CustomLoginForm {...props}/>
        </Login>
    );
}

export default CustomLoginPage;
